import { type PropsWithChildren } from 'react';

import { GaugeChartFormatterContext } from '../contexts/GaugeChartFormatterContext.js';
import { GaugeChartLabelsContext } from '../contexts/GaugeChartLabelsContext.js';
import { GaugeChartRangeMaxContext } from '../contexts/GaugeChartRangeMaxContext.js';
import { GaugeChartRangeMinContext } from '../contexts/GaugeChartRangeMinContext.js';
import { GaugeChartSizeContext } from '../contexts/GaugeChartSizeContext.js';
import { GaugeChartThresholdContext } from '../contexts/GaugeChartThresholdContext.js';
import type { GaugeChartInternalConfig } from '../types/gauge-chart-config-internal.js';

export interface GaugeChartProvidersProps {
  config: GaugeChartInternalConfig;
  width: number;
  height: number;
}

export const GaugeChartProviders = ({
  config,
  width,
  height,
  children,
}: PropsWithChildren<GaugeChartProvidersProps>) => {
  const {
    formatter,
    max,
    min,
    labelSlot,
    maxLabelSlot,
    minLabelSlot,
    thresholds,
    valueLabelSlot,
  } = config;

  return (
    <GaugeChartSizeContext.Provider value={{ width, height }}>
      <GaugeChartFormatterContext.Provider value={formatter}>
        <GaugeChartThresholdContext.Provider value={thresholds ?? []}>
          <GaugeChartLabelsContext.Provider
            value={{
              label: labelSlot,
              maxLabel: maxLabelSlot,
              minLabel: minLabelSlot,
              valueLabel: valueLabelSlot,
            }}
          >
            <GaugeChartRangeMinContext.Provider value={min}>
              <GaugeChartRangeMaxContext.Provider value={max}>
                {children}
              </GaugeChartRangeMaxContext.Provider>
            </GaugeChartRangeMinContext.Provider>
          </GaugeChartLabelsContext.Provider>
        </GaugeChartThresholdContext.Provider>
      </GaugeChartFormatterContext.Provider>
    </GaugeChartSizeContext.Provider>
  );
};

GaugeChartProviders['displayName'] = 'GaugeChartProviders';
